import React, { useState, useEffect } from 'react';
import Footer from '../containers/footer';
import Header from '../containers/header';
import ContentRow from '../components/book_card/ContentRow.js';
import Loading from '../components/loading/loading.js';
import { getContentsBySearch } from '../services/contents.js';
import { Box, Chip, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

import '../components/book_card/book.scss';

const SearchView = ({ match }) => {
  const searchTerm = match?.params?.search || '';

  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(searchTerm);

  useEffect(() => {
    setLoading(true);
    getContentsBySearch(searchTerm, 1).then(response => {
      setContents(response.data || []);
      setLoading(false);
    });
  }, [searchTerm]);

  const handleSearch = () => {
    if (search.length > 0) window.location.href = '/search/' + search;
  };

  const paddingSx = {
    padding: '0 160px',
    '@media (max-width: 1280px)': { padding: '0 80px' },
    '@media (max-width: 1024px)': { padding: '0 20px' },
    '@media (max-width: 600px)': { padding: '0 12px' },
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header loggedIn={true} />

      {/* Barra de título + busca */}
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginTop: '80px',
        marginBottom: '24px',
        '@media (max-width: 600px)': { marginTop: '70px' },
        ...paddingSx,
      }}>
        {/* Linha 1: Voltar + título + badge */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <IconButton
            onClick={() => window.history.back()}
            size="small"
            sx={{ color: '#3E3D3D', flexShrink: 0 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h1" sx={{
            fontWeight: 500, fontSize: '28px', lineHeight: '40px', color: '#3E3D3D',
            '@media (max-width: 600px)': { fontSize: '20px', lineHeight: '28px' },
          }}>
            Resultados para "{searchTerm}"
          </Typography>
          {!loading && contents.length > 0 && (
            <Chip
              label={contents.length}
              size="small"
              sx={{ backgroundColor: '#006494', color: '#fff', fontWeight: 700, fontSize: '13px' }}
            />
          )}
        </Box>

        {/* Linha 2: Campo de nova busca */}
        <Box sx={{
          position: 'relative',
          width: '340px',
          '@media (max-width: 600px)': { width: '100%' },
        }}>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSearch()}
            placeholder="Buscar conteúdos, arquivos e categorias..."
            style={{
              width: '100%',
              padding: '8px 44px 8px 14px',
              background: '#fff',
              border: '1px solid rgba(0,0,0,0.18)',
              borderRadius: '8px',
              fontSize: '14px',
              color: '#3E3D3D',
              outline: 'none',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              boxSizing: 'border-box',
            }}
          />
          <IconButton
            onClick={handleSearch}
            sx={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', color: '#9e9e9e' }}
          >
            <SearchOutlinedIcon />
          </IconButton>
        </Box>
      </Box>

      {/* Lista */}
      <Box sx={{ flexGrow: 1, ...paddingSx }}>
        {loading ? (
          <Loading />
        ) : contents.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {contents.map((content, index) => (
              <ContentRow
                key={`${content.id}-${index}`}
                contentId={content.id}
                categoryId={content.category_id}
                categorySlug={content.category_slug}
                showCategoryBadge={true}
                premium={content.premium}
                title={content.title}
                description={content.description}
                link={content.locale}
                document_count={content.document_count}
                extensions={content.extensions}
                updated_at={content.updated_at}
              />
            ))}
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '50px' }}>
            <Typography variant="h5">Nenhum resultado encontrado para "{searchTerm}".</Typography>
            <button
              className="card-button btns"
              style={{ width: '204px', marginTop: '24px', padding: '0' }}
              onClick={() => (window.location.href = '/category')}
            >
              Voltar para conteúdos
            </button>
          </Box>
        )}
      </Box>

      <Footer />
    </Box>
  );
};

export default SearchView;
